import React, { useState, useEffect, Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router'

import { sectionPageView } from '../../store/app'
import { getCanonical, getImageSize, getImage } from '../components/ui/articleutils'
import { formatAgo } from '../components/ui/dateutils'
import { ImageOrNoImage } from 'ion-image'
import NoImage from '../static/no-image.png'
import BookmarkImg from '../static/general/glam-notifications-page.jpg'
import StyledLink from '../components/StyledLink'
import { bm } from '../db'

const BookmarkedArticles = ({ articles }) => {
  return (
    <div>
      <div className='notifications-articles'>
        {articles.map((article, index) => (
          <Fragment key={index}>
            <article key={article.uuid}>
              <StyledLink to={'/' + getCanonical(article)} display='flex'>
                <div>
                  <h6>{article.headline}</h6>
                  <p>By {article.author} | Published {formatAgo(article.published, true)}</p>
                </div>
                <div>
                  <ImageOrNoImage image={getImage(article)} width={getImageSize('push')} alt={article.headline} shape='square' noImage={NoImage} />
                </div>
              </StyledLink>
            </article>
          </Fragment>
        ))}
      </div>
    </div>
  )
}

const BookmarksPage = props => {
  const [bookmarkedArticles, setBookmarkedArticles] = useState([])
  useEffect(() => {
    bm.messages.reverse().toArray().then(entries => setBookmarkedArticles(entries.map(entry => entry.article)))
  }, [])
  useEffect(() => {
    if (('/' + props.section) === props.location.pathname) {
      props.sectionPageView(props.location.pathname)
    }
  }, [props.section])
  return (
    <div className='wrapper'>
      <img src={BookmarkImg} alt='' />
      <h1>My Bookmarked Articles</h1>
      {bookmarkedArticles && bookmarkedArticles.length > 0 &&
        <BookmarkedArticles articles={bookmarkedArticles} />}
      {bookmarkedArticles && bookmarkedArticles.length < 1 &&
        <div className='static-page'>
          <p>You are able to bookmark articles for offline or later reading.</p>
          <p>The site header has a bookmark icon available when you are on an article. Clicking on that icon adds the article to your store.</p>
        </div>}
    </div>
  )
}

const mapDispatchToProps = (dispatch) => bindActionCreators({ sectionPageView }, dispatch)

export default withRouter(connect(mapDispatchToProps)(BookmarksPage))
